import React from 'react';
import {ExhibitInformationData} from "types/Exhibit";

type Props = {
    section: ExhibitInformationData
}

function InformationArticle({section}: Props) {
    return (
        <li className="mt-4">
            <article>
                <h3 className="text-base font-semibold">{section.name}</h3>
                <p className="leading-6 whitespace-pre-line">{section.content}</p>
            </article>
        </li>
    );
}

export default InformationArticle;